import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Oauth2Client } from '@benefitsui/app/api/benefits-clients';
import { environment } from '@benefitsui/environments/environment';
@Component({
  selector: 'app-login-page',
  templateUrl: './demologin-page.component.html',
  styleUrls: ['./demologin-page.component.scss'],
  standalone: false
})
export class DemoLoginPageComponent implements OnInit {
  clientId: string = environment.clientId;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private oauth2Client: Oauth2Client) {
    this.loginForm = this.fb.group({
          username: ['', [Validators.required]],
          password: ['', [Validators.required]]
        });
  }

  errorMessage: string | undefined;
  showErrorModal = false;
  loginForm: FormGroup;
  
  async onSubmit(): Promise<void> {
    if (this.loginForm.valid) {
      const demoClientId = this.generateDemoClientId();
      const usernameControl = this.loginForm.get('username');
      const passwordControl = this.loginForm.get('password');
      this.oauth2Client
      .demotoken({
        demoName: usernameControl?.value ?? '',
        demoId: passwordControl?.value ?? '',
        clientId: demoClientId
      })
      .subscribe((response) => {
        if ((response.data ?? false)) {
          this.navigateToPage('benefits/search');
        } else {
          this.showErrorModal = true;
          this.errorMessage = 'Demo user not found in system or invalid username and password entered!';
          this.navigateToPage('demologin');
        }
      });
    } 
    else {
      this.showErrorModal = true;
      this.errorMessage = 'Please enter username and password';
    }
  }

  async ngOnInit(): Promise<void> {
  }

  private async navigateToPage(path: string): Promise<void> {
    try {
      sessionStorage.setItem('login_destination_path', path);
      await this.router.navigate([path]);
    } catch (error) {
      console.log('error navigating to state', error);
    }
  }

  modalClose() {
    this.showErrorModal = false;    
    this.loginForm.get('username')?.setValue('');
    this.loginForm.get('password')?.setValue('');
  }

  private generateDemoClientId(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
}
